/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/// <reference lib="esnext.asynciterable" />
export { getContinuationToken } from "./pagingHelper.js";
export * from "./models/index.js";
export { ComputeManagementClient } from "./computeManagementClient.js";
export * from "./operationsInterfaces/index.js";
